export var ClientTypesList = [
    { text: "Clients Détail", value: "CLIENT"},
    { text: "Clients Gros", value: "CLIENT_GROS"},
    { text: "Prospects", value: "PROSPECT" },
    { text: "Dépôts", value: "DEPOT"},
    { text: "Intermédiaire", value: "INTERMEDIAIRE"},
    { text: "Concurrents", value:"CONCURENT"},
    { text: "Parkings", value:"DRIVER"},
    { text: "Concessionnaires", value:"CONCESSIONNAIRE"}
];


export interface PageResponse<T> {
  content: T[];
  totalPages: number;
  totalElements: number;
  last: boolean;
  size: number;
  number: number;
  numberOfElements: number;
  first: boolean;
}
